"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _Loader = _interopRequireDefault(require("../../molecules/Loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullPageLoader = function FullPageLoader() {
  return /*#__PURE__*/_react.default.createElement(_core.Backdrop, {
    open: true
  }, /*#__PURE__*/_react.default.createElement(_Loader.default, null));
};

var _default = FullPageLoader;
exports.default = _default;